import PressPage from 'screens/Press/Press';

export default PressPage;
